import { render, staticRenderFns } from "./DnsFilterReport.vue?vue&type=template&id=3e54e730&"
import script from "./DnsFilterReport.vue?vue&type=script&lang=js&"
export * from "./DnsFilterReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports